import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {SharedModule} from '@shared/shared.module';
import {HomeConfigListComponent} from '@app/modules/app-config/app-config-list/home-config-list.component';
import {HomeConfigDetailComponent} from '@app/modules/app-config/home-config-detail/home-config-detail.component';
import {SectionViewComponent} from '@app/modules/app-config/components/section-view/section-view.component';
import {CoverEditorComponent} from '@app/modules/app-config/components/cover-editor/cover-editor.component';
import {BannerEditorComponent} from '@app/modules/app-config/components/banner-editor/banner-editor.component';
import {CarouselEditorComponent} from '@app/modules/app-config/components/carousel-editor/carousel-editor.component';
import {RouteSelectComponent} from '@app/modules/app-config/components/route-select/route-select.component';
import { SectionEditDialogComponent } from './components/section-edit-dialog/section-edit-dialog.component';
import { MenuEditorComponent } from './components/menu-editor/menu-editor.component';

const routes: Routes = [
    {path: 'home-config-list', component: HomeConfigListComponent},
    {path: 'home-config-detail', component: HomeConfigDetailComponent}
];

@NgModule({
    declarations: [
        HomeConfigListComponent,
        SectionViewComponent,
        CoverEditorComponent,
        BannerEditorComponent,
        CarouselEditorComponent,
        RouteSelectComponent,
        SectionEditDialogComponent,
        MenuEditorComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports: [
        SectionViewComponent,
        CoverEditorComponent,
        BannerEditorComponent,
        CarouselEditorComponent
    ],
})
export class AppConfigModule {
}
